module.exports = __webpack_public_path__ + "media/2.c3fdbf57.mp3";